import firebase from "firebase/app";
import axios from "axios";
import { message } from "antd";
import category from "../reducer/category";

type PromiseCallback = (value?: any) => void;

const registerUserWithEmail = (
  fullName: string,
  email: string,
  password: string,
  gender: string,
  phoneNumber: string,
  user: any
) => (resolve: PromiseCallback, reject: PromiseCallback) => {
  const newUser = {
    id: user && user.uid,
    fullName,
    email: user && user.email,
    gender,
    photoUrl: user && user.photoURL,
    instagram: "",
    friends: "",
    emailVerified: false,
    phoneNumber,
    club: "",
    phoneNumberVerified: false,
    creationTime: new Date().toISOString(),
    lastSignInTime: new Date().toISOString(),
    role: "regular",
  };
  firebase
    .firestore()
    .collection("users")
    .doc(user?.uid)
    .set(newUser)
    .then(() => {
      resolve(newUser);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log("Error", error);
      reject(error);
    });
};

const loginUser = (user: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  firebase
    .firestore()
    .collection("users")
    .doc(user.uid)
    .update({ lastSignInTime: new Date().toISOString() });
  firebase
    .firestore()
    .collection("users")
    .doc(user.uid)
    .get()
    .then((doc) => {
      if (doc.exists) {
        // Get Country code
        const userData = doc.data();
        axios.get('https://ipapi.co/json/').then((response) => {
          const { data } = response;
          const { country } = data;
          const countryCode = data.country_code;
          resolve({ ...userData, country, countryCode });
        }).catch((error) => {
          console.log("get location error:", error);
          alert("Get location error!");
          resolve({ ...userData, country: "", countryCode: "" });
        });
        // End get country code
      } else {
        // eslint-disable-next-line no-console
        console.log("No such document!");
        reject("No such document!");
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log("Error getting document:", error);
      reject(error);
    });
};

const fetchProducts = async (payload: any) => {
  try {
    const { currentUser } = payload;
    const querySnapshot = currentUser?.role === "admin" ?
      await firebase.firestore().collection("products").get() :
      await firebase.firestore().collection("products").where("id", "==", currentUser?.id).get();
    const allProducts: any[] = [];
    querySnapshot.forEach(async (doc) => {
      const values = doc.data();
      values.shipping = values.shipping === 1 ? "YES" : "NO";
      values.visibility = values.visibility === 1 ? "YES" : "NO";
      values.condition = values.condition === 1 ? "Excellent" : values.condition;
      values.condition = values.condition === 2 ? "Good" : values.condition;
      values.condition = values.condition === 3 ? "Heavily Used" : values.condition;
      values.condition = values.condition === 4 ? "New" : values.condition;
      allProducts.push({ ...values, key: doc.id });
    });

    const products: any = await Promise.all(
      allProducts.map(async (pro) => {
        let catego = "";
        let subcategory = "";
        const categoryList = await firebase.firestore().collection("category").where("catID", "==", pro.category).get();
        categoryList.forEach((docs) => {
          catego = docs.data().name;
        });

        if (pro.subcategory) {
          const subCategoryList = await firebase.firestore().collection("category").where("catID", "==", pro.subcategory).get();
          subCategoryList.forEach((docs) => {
            subcategory = docs.data().name;
          });
        } else {
          subcategory = "none";
        }
        return {
          ...pro,
          changedCategory: catego,
          changedSubcategory: subcategory
        }
      })
    )
    return products;
  } catch (error) {
    console.error(error);
  }
  return null;
}


const fetchAllCategory = async (payload: any) => {
  try {
    const querySnapshot = await firebase.firestore().collection("category").orderBy("catID", "desc").get();
    const allCategories: any[] = [];
    querySnapshot.forEach(async (doc) => {
      const categoryData = doc.data();
      if (categoryData.parent === 0) {
        categoryData.parent = "None";
      } else {
        const categoryList = await firebase.firestore().collection("category").where("catID", "==", categoryData.parent).get();
        categoryList.forEach((docs) => {
          categoryData.parent = docs.data().name;
        });
      }
      allCategories.push({ ...categoryData, key: doc.id });
    });
    return allCategories;
  } catch (error) {
    console.error(error);
  }
  return null;
};

const fetchAllClubsAPI = async (payload: any) => {
  try {
    const { currentUser } = payload;
    const querySnapshot = await firebase.firestore().collection("clubs").get();
    const allClubs: any[] = [];
    querySnapshot.forEach((doc) => {
      const count = 0;
      if (currentUser.role === "manager") {
        if (currentUser.club === doc.id) allClubs.push({ ...doc.data(), courtNumber: count, key: doc.id });
      } else {
        const clubData = doc.data();
        allClubs.push({ ...clubData, courtNumber: count, key: doc.id });
      }
    });
    const clubs = await Promise.all(
      allClubs.map(async (club) => {
        return firebase.firestore().collection("branches").where("club", "==", club.key).get()
          .then((snapshot) => ({
            ...club,
            countOfBranches: snapshot.size,
            locations: snapshot.docs.map((s) => s.data().location),
            manager_data: null,
          }));
      })
    );
    return clubs;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  return null;
};

const createClubAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const currentTime = new Date().toISOString();
  const clubData = { ...payload, website: `https://${payload.website}`, createdAt: currentTime, updatedAt: currentTime };
  firebase
    .firestore()
    .collection("clubs")
    .doc(clubData.clubId)
    .set(clubData)
    .then(() => {
      message.success("New club has been created successful!");
      resolve({ ...clubData, manager_data: undefined })
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error adding document: ", error);
      message.error("Something went wrong! Please try again later!");
      reject(error);
    });
};

const editClubAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const {
    clubId,
    firestoreRef,
    name,
    manager,
    description,
    website,
    photo,
    contactEmail,
    contactPhone,
    facebook,
    instagram,
    linkedIn,
    twitter,
    currency,
    price,
    // enable,
    bookingDatesRange,
    status,
    show,
    country,
    payOverCount,
    currentUser,
  } = payload;
  const currentTime = new Date().toISOString();
  firebase
    .firestore()
    .collection("clubs")
    .doc(firestoreRef)
    .update({
      name,
      manager,
      description,
      website: `https://${website}`,
      photo,
      contactEmail,
      contactPhone,
      facebook,
      instagram,
      linkedIn,
      twitter,
      price,
      currency,
      // enable,
      bookingDatesRange,
      show,
      status,
      country,
      payOverCount,
      updatedAt: currentTime,
    });
  firebase
    .firestore()
    .collection("clubs")
    .get()
    .then(async (querySnapshot) => {
      const allClubs: any[] = [];
      querySnapshot.forEach((doc) => {
        const count = 0;
        if (currentUser.role === "manager") {
          if (currentUser.club === doc.id) allClubs.push({ ...doc.data(), courtNumber: count, key: doc.id });
        }
        else {
          const clubData = doc.data();
          allClubs.push({ ...clubData, courtNumber: count, key: doc.id });
        }
      });
      const clubs = await Promise.all(
        allClubs.map(async (club) => {
          let managerData: any;
          return firebase
            .firestore()
            .collection("branches")
            .where("club", "==", club.key)
            .get()
            .then((snapshot) => ({
              ...club,
              countOfBranches: snapshot.size,
              manager_data: null
            }));
        })
      );
      message.success("Club has beed updated successful!");
      resolve(clubs);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error fetch clubs: ", error);
      message.error("Something went wrong! Please try again later!");
      reject(error);
    });
};

const deleteClubAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { key, currentUser } = payload;
  firebase
    .firestore()
    .collection("clubs")
    .doc(key)
    .delete()
    .then(() => {
      firebase
        .firestore()
        .collection("clubs")
        .get()
        .then(async (querySnapshot) => {
          const allClubs: any[] = [];
          if (querySnapshot.docs.length) {
            querySnapshot.forEach((doc) => {
              if (currentUser.role === "manager") {
                if (currentUser.id === doc.data().manager) {
                  allClubs.push({ ...doc.data(), key: doc.id });
                }
              }
              if (currentUser.role === "admin") {
                allClubs.push({ ...doc.data(), key: doc.id });
              }
            });
            const clubs = await Promise.all(
              allClubs.map(async (club) => {
                return firebase
                  .firestore()
                  .collection("courts")
                  .where("clubId", "==", club.key)
                  .get()
                  .then((snapshot) => ({
                    ...club,
                    courtNumber: snapshot.size,
                    manager_data: null,
                  }));
              })
            );

            message.success("Club has been deleted!")
            resolve(clubs);
          } else {
            message.error("Something went wrong! please try again later.");
            resolve([]);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Error fetch clubs: ", error);
          reject(error);
        });
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error("Error removing document: ", e);
      reject(e);
    });
};

const fetchAllUsersAPI = () => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  firebase
    .firestore()
    .collection("users")
    .get()
    .then((querySnapshot) => {
      const allUsers: any[] = [];
      querySnapshot.forEach((doc) => {
        if (doc.data().role !== "admin") {
          allUsers.push({ ...doc.data(), key: doc.id });
        }
        resolve(allUsers);
      });
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error fetch users: ", error);
      reject(error);
    });
};

const updateUserAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { id, fullName, email, photoUrl, role } = payload;
  const currentTime = new Date().toISOString();
  firebase.firestore().collection("users").doc(id).update({
    fullName,
    email,
    photoUrl,
    lastSignInTime: currentTime,
    role,
  });
  firebase
    .firestore()
    .collection("users")
    .get()
    .then((querySnapshot) => {
      const allUsers: any[] = [];
      querySnapshot.forEach((doc) => {
        if (doc.data().role !== "admin") {
          allUsers.push({ ...doc.data(), key: doc.id });
        }
        resolve(allUsers);
      });
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error update user: ", error);
      reject(error);
    });
};

const createCategory = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const categoryData = { ...payload };
  firebase
    .firestore()
    .collection("category")
    .doc(categoryData.catID)
    .set(categoryData)
    .then(() => {
      message.success("New category has been created successful!");
      resolve({ ...categoryData, manager_data: undefined })
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error adding document: ", error);
      message.error("Something went wrong! Please try again later!");
      reject(error);
    });
}

const createProduct = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const productData = { ...payload };
  firebase
    .firestore()
    .collection("products")
    .doc(productData.product_id)
    .set(productData)
    .then(() => {
      message.success("New product has been created successful!");
      resolve({ ...productData, manager_data: undefined })
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
      message.error("Something went wrong! Please try again later!");
      reject(error);
    });
}

const editCategoryItem = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { name, keyword, parent, currentId } = payload;

  firebase.firestore().collection("category").doc(currentId).update({
    name,
    keyword,
    parent,
  })
    .then((res) => {
      resolve(payload);
    })
    .catch((err) => {
      reject(err);
    });
}

const editProduct = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const productData = { ...payload };
  const { currentId } = payload;
  console.log(productData);
  firebase.firestore().collection("products").doc(currentId).update(payload)
    .then((res) => {
      message.success("Product has been updated!");
      resolve(payload);
    })
    .catch((err) => {
      reject(err);
    });
}


const removeProduct = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { currentId } = payload;
  firebase
    .firestore()
    .collection("products")
    .doc(currentId)
    .delete()
    .then(() => {

    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error("Error removing document: ", e);
      reject(e);
    });
}


const removeCategory = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { currentId } = payload;
  firebase
    .firestore()
    .collection("category")
    .doc(currentId)
    .delete()
    .then(() => {

    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error("Error removing document: ", e);
      reject(e);
    });
}

const buyProductRequest = (payload: any) => async (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  firebase
    .firestore()
    .collection("request_item")
    .doc(payload.request_id)
    .set(payload)
    .then(async () => {
      const productSnapshots = await firebase.firestore().collection("products").doc(payload.product_id).get();
      const productData = productSnapshots.data();
      const updatedQty = Number(productData?.quantity) - Number(payload?.qty);
      firebase.firestore().collection("products").doc(payload.product_id).update({ quantity: updatedQty })
        .then((res) => {
          resolve(payload);
        })
        .catch((err) => {
          reject(err);
        });
      resolve(payload)
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
      message.error("Something went wrong! Please try again later!");
      reject(error);
    });
}

const getOrderRequest = (payload: any) => async (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  try {
    const querySnapshot = await firebase.firestore().collection("request_item").where("seller", "==", payload?.vendor).get();
    const requestedItem: any[] = [];
    querySnapshot.forEach(async (doc) => {
      const itemData = doc.data();
      const buyerSnapshot = await firebase.firestore().collection("users").doc(itemData.buyer).get();
      const buyerData = buyerSnapshot.data();
      requestedItem.push({ ...itemData, buyerInfo: buyerData?.fullName });
    });
    resolve(requestedItem);
  } catch (error) {
    console.error(error);
  }
  resolve(null);
}


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseEmailRegister = (
  fullName: string,
  email: string,
  password: string,
  gender: string,
  phoneNumber: string,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  user: any
): any => new Promise(registerUserWithEmail(fullName, email, password, gender, phoneNumber, user));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseLogin = (user: any): any => new Promise(loginUser(user));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseFetchAllClubs = (payload: any): any =>
  fetchAllClubsAPI(payload);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseCreateClub = (payload: any): any =>
  new Promise(createClubAPI(payload));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseEditClub = (payload: any): any =>
  new Promise(editClubAPI(payload));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseDeleteClub = (payload: any): any =>
  new Promise(deleteClubAPI(payload));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseFetchAllUsers = (): any => new Promise(fetchAllUsersAPI());

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseEditUser = (payload: any): any =>
  new Promise(updateUserAPI(payload));

export const firebaseCreateCategory = (payload: any): any =>
  new Promise(createCategory(payload))

export const firebaseCreateProduct = (payload: any): any =>
  new Promise(createProduct(payload))

export const firebaseFetchAllProducts = (payload: any): any =>
  fetchProducts(payload);

export const firebaseFetchAllCategories = (payload: any): any =>
  fetchAllCategory(payload);

export const firebaseEditCategory = (payload: any): any =>
  new Promise(editCategoryItem(payload))

export const firebaseEditProduct = (payload: any): any =>
  new Promise(editProduct(payload));

export const firebaseRemoveProduct = (payload: any): any =>
  new Promise(removeProduct(payload));


export const firebaseRemoveCategory = (payload: any): any =>
  new Promise(removeCategory(payload));

export const firebaseBuyProductRequest = (payload: any): any =>
  new Promise(buyProductRequest(payload));

export const firebaseGetOrderRequestFn = (payload: any): any =>
  new Promise(getOrderRequest(payload));
